import { IssueRequiredField } from '@qality/common-model';
import {
  CreateMetadataService,
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

export default {
  async getFields(projectKey: string): Promise<Array<IssueRequiredField>> {
    return CreateMetadataService.getQAlityIssueTypeFields(projectKey);
  },
  async addTestCaseIssueTypeToProjectScheme(projectId: string): Promise<void> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_QALITY_TEST_ISSUE_TYPE
    );
    await axios.put(
      url,
      { id: projectId },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  },

  async removeTestCaseIssueTypeFromProjectScheme(
    projectId: string
  ): Promise<void> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_QALITY_TEST_ISSUE_TYPE +
        '/' +
        projectId
    );
    await axios.delete(`${url}`);
  },
};
